import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';

import { TooltipWrapper } from '../TooltipWrapper';

const style: React.CSSProperties = { width: '100%', height: '80%' };
const spanStyle: React.CSSProperties = { whiteSpace: 'nowrap' };

interface ICustomHeaderParams extends IHeaderParams {
    customHeaderName?: () => JSX.Element;
}

export const AgTooltipHeaderComponent: React.FC<ICustomHeaderParams> = (props) => {
    const { displayName, customHeaderName } = props;

    return (
        <div className="ag-header-cell-label">
            <TooltipWrapper message={displayName} size="m" isInteractive={false} style={style}>
                <span className="ag-header-cell-text" style={spanStyle}>
                    {customHeaderName?.() || displayName}
                </span>
            </TooltipWrapper>
        </div>
    );
};

AgTooltipHeaderComponent.displayName = 'AgTooltipHeaderComponent';
